import sendChatMessageOperation from 'owa-service/lib/operation/sendChatMessageOperation';
import ucmaServiceOptions from './ucmaServiceOptions';
import chatMessage from 'owa-service/lib/factory/chatMessage';

export default function sendChatMessage(
    sessionId: number,
    recipients: string[],
    message: string,
    subject: string
): Promise<number> {
    return sendChatMessageOperation(
        {
            message: chatMessage({
                Body: message,
                ChatSessionId: sessionId,
                Subject: subject,
                Recipients: recipients,
            }),
        },
        ucmaServiceOptions
    );
}
